export default "__VITE_ASSET__CduP8o6V__"